// Convert kebab-case to camelCase: my-page-asset > myPageAsset
export const camelize = s => s.replace(/-(.)/g, l => l[1].toUpperCase());

export const extractYouTubeID = url => {
  const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts|live)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
  const match = url ? url.match(regExp) : null;

  return match ? match[1] : null;
};

export const getTitleAfterHyphen = title => {
  if (!title || typeof title !== 'string') return '';
  const parts = title.split(/[-–—]/);
  if (parts.length > 1) {
    return parts.slice(1).join('-').trim();
  }
  return '';
};

/**
 * Title-case each space-separated word: first letter upper, remainder lower.
 *
 * @param {string} sentence
 * @returns {string}
 */
export const capitalizeSentence = sentence => {
  if (!sentence || typeof sentence !== 'string') {
    return '';
  }
  return sentence
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Truncate text near maxLength without splitting a word and without an ellipsis.
 * If maxLength falls inside a word, the full word is kept.
 *
 * @param {string} text
 * @param {number} maxLength
 * @returns {string}
 */
export const truncateAtWord = (text, maxLength) => {
  if (!text || typeof text !== 'string') {
    return '';
  }
  if (text.length <= maxLength) {
    return text;
  }

  // Cut landed on whitespace: keep the complete words before it
  if (/\s/.test(text.charAt(maxLength))) {
    return text.slice(0, maxLength).trimEnd();
  }

  // No spaces in the prefix (e.g. CJK): characters are already whole units
  const prefix = text.slice(0, maxLength);
  if (!/\s/.test(prefix)) {
    return prefix;
  }

  // Mid-word: include the rest of the current word
  const remainder = text.slice(maxLength);
  const nextWhitespace = remainder.search(/\s/);
  if (nextWhitespace === -1) {
    return text.trimEnd();
  }
  return text.slice(0, maxLength + nextWhitespace).trimEnd();
};

